import React from 'react';
import TextEditor from '../TextEditor/TextEditor';
import { EditorialType } from '../../domain/domain';

const TestPage : React.FC = () => {
    let text = `<div style="text-align: center;"><span><span><span><span><span><span><span style="font-size: 38px">sdafdsf</span></span></span></span></span></span></span></div>`;
    return (
        <>
            <TextEditor
                html={text}
                showToolbar={true}
                readOnly={false}
                editorStyle={{}}
                selectedEditorialType={EditorialType.ANALYSIS}
                onChange={() => {

                }}
            />
        </>
    )
}

export default TestPage;